/*eslint-disable*/
import {
	TextField,
	withStyles,
	Typography,
	Divider,
	CircularProgress
} from '@material-ui/core';
import React from 'react';

const styles = theme => ({
	textField: {
		width: '100%',
		marginTop: 0,
		marginBottom: 0
	}
});

function isEmptyOrSpaces(str) {
	return (
		str === undefined || str === null || str.toString().match(/^ *$/) !== null
	);
}

class AutofillV3 extends React.Component {
	state = {
		listOpen: false
	};

	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);

		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleChange = event => {
		event.preventDefault();
		this.setState({ listOpen: true });

		if (this.props.input.onChange && !this.props.readOnly) {
			this.props.input.onChange(event);
			this.props.input.onBlur(event);
		}
	};

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.meta.touched ||
			nextProps.input.value !== this.props.input.value ||
			nextProps.p_value !== this.props.p_value
		) {
			this.forceUpdate();
		}
	}

	shouldComponentUpdate() {
		return true;
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	setListOpen = () => {
		this.setState({ listOpen: true });
	};

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({ listOpen: false });
		}
	}

	selectItem = (displayText, value) => {
		this.setState({ listOpen: false });
		this.props.input.onChange(displayText);
		this.props.onItemSelect(displayText, value);
	};

	render() {
		this.props.meta.valid = false;

		let trySubmit = this.props.checkValidation ? true : false;

		const {
			meta: { touched, error, warning }
		} = this.props;

		let lValue = this.props.fixedValue
			? this.props.fixedValue
			: this.props.input.value
			? this.props.input.value
			: '';

		let searchForItems = false;

		if (!isEmptyOrSpaces(lValue) && lValue.length > 2) {
			if (this.props.autoFillList.length > 0) {
				searchForItems = true;
			}
		}

		let lOutputComponent = (
			<div ref={this.setWrapperRef}>
				<TextField
					onMouseDown={() => this.setListOpen()}
					onChange={this.handleChange}
					id={this.props.input.name}
					value={lValue}
					label={this.props.label}
					className={this.props.classes.textField}
					margin="normal"
					error={
						error && error.length > 0 && touched
							? true
							: error && error.length > 0 && trySubmit
							? true
							: false
					}
					helperText={(error && touched) || (error && trySubmit) ? error : null}
					placeholder={this.props.placeholder}
				/>
				{lValue.length > 2 && this.props.autoFillList && this.state.listOpen ? (
					<div
						className="autofillList"
						style={{
							zIndex: this.props.zIndex ? this.props.zIndex : 'auto',
							position: this.props.absolute ? 'absolute' : 'relative'
						}}
					>
						{this.props.loading ? (
							<div
								style={{ textAlign: 'center', width: '100%', marginTop: '5px' }}
							>
								<CircularProgress size={25} />
							</div>
						) : null}
						{this.props.autoFillList.length < 1 && !this.props.loading ? (
							<Typography
								style={{ padding: '10px', color: 'red' }}
								variant="body1"
							>
								No {this.props.listName} Found
							</Typography>
						) : null}
						{this.props.autoFillList.map((a, i) => (
							<div
								key={i}
								className="autofillItem"
								onClick={() => this.selectItem(a[this.props.displayText], a.id)}
							>
								<Typography style={{ padding: '10px' }} variant="body1">
									{a[this.props.displayText]}
									<Typography variant="caption">
										{a[this.props.subText]}
									</Typography>
								</Typography>
							</div>
						))}
					</div>
				) : null}
			</div>
		);

		return <div>{lOutputComponent}</div>;
	}
}

export default withStyles(styles)(AutofillV3);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/AutofillV3.js